import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  Select,
  MenuItem,
  makeStyles,
  InputBase,
} from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 150,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: theme.shadows[1],
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  select: {
    fontSize: "0.95rem",
    fontWeight: 500,
    borderRadius: 12,
    backgroundColor: "transparent",
    color: theme.palette.text.primary, // Normal state
    "&.MuiSelect-outlined": {
      color: theme.palette.text.primary, // ✅ Selected value
    },
    "&.MuiSelect-select": {
      color: theme.palette.text.primary, // ✅ Dropdown selected item
    },
    "&:focus": {
      backgroundColor: "transparent",
      color: theme.palette.text.primary, // ✅ Focus state
    },
  },

  inputBase: {
    padding: "6px 12px",
    color: theme.palette.text.primary,
  },
  menuItem: {
    fontSize: "0.95rem",
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    color: theme.palette.text.primary,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&.Mui-selected": {
      fontWeight: 600,
      backgroundColor: theme.palette.action.selected,
    },
    "&.Mui-selected:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const languages = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  // { code: "fr", label: "French" },
  // { code: "dutch", label: "Dutch" },
  { code: "bangla", label: "Bengali" },
  { code: "tamil", label: "Tamil" },
  // { code: "ar", label: "Arabic" },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl className={classes.formControl} variant="outlined">
      <LanguageIcon className={classes.icon} />
      <Select
        value={i18n.language}
        onChange={handleChange}
        classes={{ root: classes.select }}
        disableUnderline
        input={<InputBase classes={{ input: classes.inputBase }} />}
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          transformOrigin: { vertical: "top", horizontal: "right" },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              marginTop: 8,
              borderRadius: 12,
              padding: "5px 10px",
              fontSize: "0.95rem",
              minWidth: 150,
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
          },
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            value={lang.code}
            className={classes.menuItem}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
